import React, {Component} from 'react';
import {FuseSplashScreen} from '@fuse';
import {connect} from 'react-redux';
import * as userActions from 'app/auth/store/actions';
import {bindActionCreators} from 'redux';
import * as Actions from 'app/store/actions';
import rlaService from 'app/services/rlaService';

class Auth extends Component {

    state = {
        waitAuthCheck: true
    }

    componentDidMount()
    {
        return Promise.all([
            this.rlaCheck()
        ]).then(() => {
            this.setState({waitAuthCheck: false})
        })
    }

    rlaCheck = () => new Promise(resolve => {

        rlaService.on('onAutoLogin', () => {
            rlaService.signInWithToken()
                .then(user => {
                    this.props.setUserData(user);
                    resolve();
                })
                .catch(error => {
                    this.props.showMessage({message: error});
                    resolve();
                })
        });

        rlaService.on('onAutoLogout', (message) => {
            const self = this
            setTimeout(function() {
                self.setState({waitAuthCheck: false})

                if (message) {
                    self.props.showMessage({message});
                }
            }, 1000)

            this.props.logout();

            resolve();
        });

        rlaService.on('onNoAccessToken', () => {
            this.setState({waitAuthCheck: true})

            resolve();
        });

        rlaService.on('onSignInComplete', () => {
            this.setState({waitAuthCheck: false})

            resolve();
        });

        rlaService.init();

        return Promise.resolve();
    })

    render()
    {
        return this.state.waitAuthCheck ? <FuseSplashScreen/> : <React.Fragment children={this.props.children}/>;
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
            logout             : userActions.logoutUser,
            setUserData        : userActions.setUserData,
            showMessage        : Actions.showMessage,
            hideMessage        : Actions.hideMessage
        },
        dispatch);
}

export default connect(null, mapDispatchToProps)(Auth);
